import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { DimensionNoFormSelection as DimensionSelection, InterestDimensionSelectionNoForm } from './EditFormSection';
import { filterSelectedDimensions } from '../../../../../utils/TemplateUtil';
import ArrayUtil from '../../../../../utils/ArrayUtil';
import { intlShape } from '../../../../../components/prop-types';

const messages = defineMessages({
  behaviors: { id: 'jobMatching.behaviorSection', defaultMessage: 'Behaviors section' },
  cognitive: { id: 'jobMatching.cognitiveSection', defaultMessage: 'Cognitive section' },
});

class DimensionList extends Component {
  render() {
    const {
      behaviorDimensions,
      cognitiveDimensions,
      interestsDimensions,
      assessmentSections,
      intl: { formatMessage },
    } = this.props;
    const { behaviorSection, cognitiveSection, interestsSection } = assessmentSections;
    const behaviorSectionNormal = behaviorSection.dimensions;
    const checked = interestsDimensions && ArrayUtil.isNotEmpty(interestsDimensions);
    const filterredBehavior = filterSelectedDimensions(behaviorSectionNormal, behaviorDimensions);
    const filterredCognitive = filterSelectedDimensions(cognitiveSection.dimensions, cognitiveDimensions);
    return (
      <div>
        <div className="row">
          <div className="col-xs-12">
            <DimensionSelection
              dimensions={filterredBehavior}
              text={formatMessage(messages.behaviors)}
              defaultDimension={behaviorDimensions}
            />
          </div>
          <div className="col-xs-12">
            <DimensionSelection
              dimensions={filterredCognitive}
              text={formatMessage(messages.cognitive)}
              defaultDimension={cognitiveDimensions}
            />
          </div>
          <div className="col-xs-12">
            {checked && (
              <InterestDimensionSelectionNoForm
                dimensions={interestsSection.dimensions}
                fieldName="interest"
                checked={checked}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

DimensionList.propTypes = {
  behaviorDimensions: PropTypes.arrayOf(PropTypes.any),
  cognitiveDimensions: PropTypes.arrayOf(PropTypes.any),
  interestsDimensions: PropTypes.arrayOf(PropTypes.any),
  assessmentSections: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
};

DimensionList.defaultProps = {
  behaviorDimensions: [],
  cognitiveDimensions: [],
  interestsDimensions: [],
};

export default injectIntl(DimensionList);
